import { render, staticRenderFns } from "./demo-alcohol-promo-flow.vue?vue&type=template&id=655f4002&scoped=true&"
import script from "./demo-alcohol-promo-flow.vue?vue&type=script&lang=js&"
export * from "./demo-alcohol-promo-flow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655f4002",
  null
  
)

export default component.exports